jQuery(document).ready(function () {
  jQuery('.image-slider:not(.slick-initialized)').each(function () {
    var $this = jQuery(this);
    $this.slick({
      arrows: true,
      dots: true,
      slide: '.img-slide',
      appendArrows: $this.find('.img-slider-pagination-arrows'),
      appendDots: $this.parent().find('.slider-3-pagination-dots'),
    });
  });
  jQuery('.img-slider:not(.slick-initialized)').each(function () {
    var $this = jQuery(this);
    $this.slick({
      arrows: true,
      dots: true,
      slide: '.img-slide',
      adaptiveHeight: false,
      appendArrows: $this.find('.img-slider-pagination-arrows'),
      appendDots: $this.parent().find('.img-slider-pagination-dots'),
    });
  });

  jQuery('.slider-3:not(.slick-initialized)').each(function () {
    var $this = jQuery(this);
    $this.slick({
      arrows: false,
      dots: true,
      slide: '.slide',
      slidesToShow: 3,
      slidesToScroll: 3,
      responsive: [
        {
          breakpoint: 950,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ],
      appendDots: $this.parent().find('.slider-3-pagination-dots')
    });
  })
});
